// extracted by mini-css-extract-plugin
export var button = "_1c-0";
export var buttonContent = "_1c-e";
export var buttonGroup = "_1c-c";
export var dontRestrainIconWidth = "_1c-a";
export var dropdownButton = "_1c-b";
export var iconContainer = "_1c-9";
export var lg = "_1c-4";
export var md = "_1c-3";
export var pending = "_1c-f";
export var sm = "_1c-2";
export var spinner = "_1c-d";
export var squared = "_1c-8";
export var wrapText = "_1c-g";
export var xl = "_1c-5";
export var xs = "_1c-1";
export var xxl = "_1c-6";
export var xxxl = "_1c-7";